@if (!viewMainHome()) {
  <app-main-index></app-main-index>
}

@if (viewMainHome()) {
  <app-main-home></app-main-home>
}
